import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { useScreen } from './useScreen';

const font = "'DM Sans', sans-serif";
const C = { turquesa:'#5dc1b9', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };

export default function TermsModal({ userId, onAccept }) {
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const { isMobile } = useScreen();

  const accept = async () => {
    if (!checked || saving) return;
    setSaving(true);
    await supabase.from('profiles').update({
      accepted_terms: true,
      accepted_at: new Date().toISOString(),
    }).eq('id', userId);
    setSaving(false);
    if (onAccept) onAccept();
  };

  return (
    <div style={{
      position:'fixed', inset:0, zIndex:99999,
      background:'rgba(0,0,0,0.7)', backdropFilter:'blur(15px)', WebkitBackdropFilter:'blur(15px)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:20,
    }}>
      <div style={{
        background:'#111', border:'1px solid rgba(255,255,255,0.1)',
        borderRadius:24, padding:isMobile?'28px 22px':'36px 32px',
        maxWidth:440, width:'100%', fontFamily:font, color:'#fff',
        boxShadow:'0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <div style={{ width:44, height:44, borderRadius:'50%', background:C.logoGrad, margin:'0 auto 16px', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <span style={{ color:'#fff', fontSize:12, fontWeight:600 }}>T&D</span>
        </div>

        <h2 style={{ fontSize:isMobile?18:20, fontWeight:500, textAlign:'center', margin:'0 0 10px' }}>Antes de comenzar</h2>
        <p style={{ fontSize:13, color:'rgba(255,255,255,0.5)', textAlign:'center', lineHeight:1.6, margin:'0 0 24px' }}>
          Para usar la plataforma necesitas aceptar nuestro Aviso de Privacidad y Términos y Condiciones.
        </p>

        <div style={{ display:'flex', gap:12, justifyContent:'center', marginBottom:24 }}>
          <a href="/privacidad" target="_blank" rel="noopener noreferrer" style={{ fontSize:13, color:C.turquesa, textDecoration:'underline', textUnderlineOffset:3 }}>Aviso de Privacidad</a>
          <a href="/terminos" target="_blank" rel="noopener noreferrer" style={{ fontSize:13, color:C.turquesa, textDecoration:'underline', textUnderlineOffset:3 }}>Términos y Condiciones</a>
        </div>

        <label onClick={() => setChecked(!checked)} style={{
          display:'flex', alignItems:'flex-start', gap:10, cursor:'pointer',
          padding:'14px 16px', borderRadius:12, border:`1px solid ${checked?C.turquesa:'rgba(255,255,255,0.1)'}`,
          background:checked?'rgba(93,193,185,0.06)':'transparent', transition:'all 0.2s', marginBottom:20,
        }}>
          <div style={{
            width:20, height:20, borderRadius:6, border:`2px solid ${checked?C.turquesa:'rgba(255,255,255,0.2)'}`,
            background:checked?C.turquesa:'transparent', display:'flex', alignItems:'center', justifyContent:'center',
            flexShrink:0, marginTop:1, transition:'all 0.2s',
          }}>
            {checked && <span style={{ color:'#fff', fontSize:12, fontWeight:700 }}>✓</span>}
          </div>
          <span style={{ fontSize:13, color:'rgba(255,255,255,0.7)', lineHeight:1.5 }}>
            He leído y acepto el Aviso de Privacidad y los Términos y Condiciones
          </span>
        </label>

        <button disabled={!checked||saving} onClick={accept} style={{
          width:'100%', padding:'14px', fontSize:15, fontWeight:500,
          background:checked?C.logoGrad:'rgba(255,255,255,0.06)',
          color:checked?'#fff':'rgba(255,255,255,0.25)',
          border:'none', borderRadius:50, cursor:checked?'pointer':'not-allowed',
          fontFamily:font, transition:'all 0.3s',
          opacity:saving?0.6:1,
        }}>
          {saving ? 'Guardando...' : 'Continuar'}
        </button>
      </div>
    </div>
  );
}
